import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-auditoria-conferidor",
  templateUrl: "./auditoria-conferidor.component.html",
  styleUrls: ["./auditoria-conferidor.component.scss"],
})
export class AuditoriaConferidorComponent implements OnInit {
  idServidor: number;
  idCidade: number;

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.idServidor = params.idServidor ? parseInt(params.idServidor) : null;
      this.idCidade = params.idCidade ? parseInt(params.idCidade) : null;
    });
  }

  goBack() {
    this.router.navigate(['/page/conferidor/servidores'], {
      queryParams: { idCidade: this.idCidade }
    });
  }
}












